
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinar/[slug]",
      function () {
        return require("private-next-pages/webinar/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinar/[slug]"])
      });
    }
  